export default function safely<T>(fn: () => T): T | void {
  try {
    return fn()
  } catch {
    // continue regardless of error
  }
}
